import React from 'react';
import reactStringReplace from 'react-string-replace';
import { FootnoteReference, FootnoteReferenceV2 } from './FootnoteReference';
export * from './FootnoteReference';
export * from './use-footnote-service';
export * from './transformTrackingText';
function replaceTextWithCallbackResult(text, cb) {
    let textWithReplacedFootnotes;
    textWithReplacedFootnotes = reactStringReplace(text, /{ft_([a-zA-Z0-9_-]+)}/g, cb);
    textWithReplacedFootnotes = reactStringReplace(textWithReplacedFootnotes, /{{footnote.reference.([a-zA-Z0-9_-]+)}}/g, cb);
    return textWithReplacedFootnotes;
}
export function renderTextWithFootnotesReferences(text) {
    const replaceCb = (match, i) => React.createElement(FootnoteReference, { key: i, footnoteId: match });
    return replaceTextWithCallbackResult(text, replaceCb);
}
export function renderTextWithFootnotesReferencesV2(text, ariaText) {
    let footnoteIndex = 0;
    const replaceCb = (match) => {
        footnoteIndex += 1;
        return (React.createElement(FootnoteReferenceV2, { key: `${match}-${footnoteIndex}`, footnoteId: match, footnoteAriaLabel: ariaText }));
    };
    const footnoteNodes = replaceTextWithCallbackResult(text, replaceCb);
    const formattedFootnoteNodes = insertSupElements(footnoteNodes);
    return formattedFootnoteNodes;
}
function insertSupElements(nodes) {
    const processedNodes = [];
    let previousWasFootnote = false;
    let supCounter = 0;
    nodes.forEach((node) => {
        const isFootnote = React.isValidElement(node) && node.type === FootnoteReferenceV2;
        const isWhitespaceString = (n) => typeof n === 'string' && n.trim() === '';
        if (isFootnote && previousWasFootnote) {
            processedNodes.push(React.createElement("sup", { translate: "no", key: `sup-${supCounter}` },
                ",",
                ' '));
            supCounter += 1;
        }
        processedNodes.push(node);
        if (!isWhitespaceString(node)) {
            previousWasFootnote = isFootnote;
        }
    });
    return processedNodes;
}
//# sourceMappingURL=index.js.map